/*
 * Copyright © 2021-present Tacnode Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Tacnode Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Tacnode Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { CheckOutlined, DownOutlined } from '@ant-design/icons'
import { Button, Dropdown, Space, theme } from 'antd'
import { ItemType } from 'antd/lib/menu/interface'
import { useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ModelContract } from 'account-client'
import styles from './index.less'
import { ContractInfo } from '@/pages/billing/features/SwitchBilling/ContractInfo'
import { accountClient } from '@/services/cloudClient/accountClient'

export function SwitchBilling() {
  const { contractId: currentContractId } = useParams()
  const navigate = useNavigate()
  const [contractList, setContractList] = useState<ModelContract[]>([])

  const { token } = theme.useToken()
  const dropdownContentStyle: React.CSSProperties = {
    backgroundColor: token.colorBgElevated,
    borderRadius: token.borderRadiusLG,
    boxShadow: token.boxShadowSecondary,
  }

  const onSelectContract = (item: ModelContract) => {
    if (currentContractId !== item.id) {
      navigate(`/billing-center/${item.id}`)
    }
  }

  const currentContract = useMemo(() => {
    return contractList.find(item => item.id === currentContractId)
  }, [contractList, currentContractId])

  const items = useMemo<ItemType[]>(
    () =>
      contractList.map(item => ({
        key: item.id,
        label: (
          <div onClick={() => onSelectContract(item)} className={styles.menuItem}>
            <span style={{ visibility: item.id === currentContractId ? 'visible' : 'hidden' }}>
              <CheckOutlined style={{ color: 'green' }} />
            </span>
            <ContractInfo contract={item} />
          </div>
        ),
      })),
    [contractList, currentContractId],
  )

  useEffect(() => {
    accountClient.contractsApi.listContracts().then(res => setContractList(res.data.items))
  }, [])

  return (
    <Dropdown
      menu={{ items }}
      trigger={['click']}
      dropdownRender={menu => (
        <div style={dropdownContentStyle} className={styles.dropdown}>
          {menu}
        </div>
      )}
    >
      <Button type="text" className={styles.button}>
        <Space>
          {`${currentContract?.tags} ${currentContract?.buyerName}（${currentContractId}）`}
          <DownOutlined />
        </Space>
      </Button>
    </Dropdown>
  )
}
